import { render, staticRenderFns } from "./feeSummaryList.vue?vue&type=template&id=62dd0ddb&scoped=true"
import script from "./feeSummaryList.vue?vue&type=script&lang=js"
export * from "./feeSummaryList.vue?vue&type=script&lang=js"
import style0 from "./feeSummaryList.vue?vue&type=style&index=0&id=62dd0ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62dd0ddb",
  null
  
)

export default component.exports